import React, { useState } from 'react';
import { Slider } from 'primereact/slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'react-toggle/style.css';
import './css/ReturnCalculator.css';

const ReturnCalculator = ({ initialReturns = 0, defaultOpen, title = 'Return Calculator', config }) => {
  const [sipMode, setSipMode] = useState(true); // true for Monthly SIP, false for One-time
  const [amount, setAmount] = useState(500); // Default amount
  const [calcDuration, setCalcDuration] = useState(3); // Default duration for calculator
  const [calculatorOpen, setCalculatorOpen] = useState(defaultOpen); // State for collapsible section
  const [adjustedReturns, setAdjustedReturns] = useState(initialReturns);

  const handleAmountChange = (e) => {
    setAmount(e.value);
  };

  const handleCalcDurationChange = (newDuration) => {
    setCalcDuration(newDuration);
  };

  const handleAdjustedReturnsChange = (e) => {
    setAdjustedReturns(e.target.value);
  };

  const calculateInvestmentReturn = () => {
    const rate = adjustedReturns / 100;
    let futureValue;
    if (sipMode) {
      // Monthly SIP calculation
      const n = calcDuration * 12;
      const monthlyRate = rate / 12;
      const monthlyAmount = amount;
      futureValue = monthlyAmount * (((1 + monthlyRate) ** n - 1) / monthlyRate) * (1 + monthlyRate);
    } else {
      // One-time investment calculation
      futureValue = amount * (1 + rate) ** calcDuration;
    }
    return futureValue.toFixed(2);
  };

  const totalInvestment = () => {
    if (sipMode) {
      return amount * 12 * calcDuration;
    } else {
      return amount;
    }
  };

  const formatNumber = (num) => {
    return new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <div className="return-calculator-section">
      <div className="calculator-toggle" onClick={() => setCalculatorOpen(!calculatorOpen)}>
        <h4>{config.title}</h4>
        <FontAwesomeIcon icon={calculatorOpen ? faChevronUp : faChevronDown} />
      </div>
      {calculatorOpen && (
        <div className="return-calculator">
          <div className="toggle-buttons">
            <button className={sipMode ? 'active' : ''} onClick={() => setSipMode(true)}>Monthly SIP</button>
            <button className={!sipMode ? 'active' : ''} onClick={() => setSipMode(false)}>One-time</button>
          </div>
          <div className="amount-slider">
            <label>Amount: {formatNumber(amount)}</label>
            <Slider value={amount} onChange={handleAmountChange} min={sipMode ? 500 : 500} max={sipMode ? 50000 : 100000} />
          </div>
          <div className="calc-duration-buttons">
            <button className={calcDuration === 1 ? 'active' : ''} onClick={() => handleCalcDurationChange(1)}>1 Year</button>
            <button className={calcDuration === 3 ? 'active' : ''} onClick={() => handleCalcDurationChange(3)}>3 Years</button>
            <button className={calcDuration === 5 ? 'active' : ''} onClick={() => handleCalcDurationChange(5)}>5 Years</button>
          </div>
          <div className="calculation-result">
            <p>Total investment of: {formatNumber(totalInvestment())}</p>
            <p>Would have become: <input type="number" className="return-calculator-input" value={adjustedReturns} onChange={handleAdjustedReturnsChange} />% (return)</p>
            <p>{formatNumber(calculateInvestmentReturn())}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReturnCalculator;
